<template>
  <v-layout align-start>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog
      v-model="dialogCancell"
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <v-toolbar color="primary" dark> <h3>Confirmación de Cancelación</h3></v-toolbar>
      <v-card>
        <v-card-text class="pa-7">
          <span class=""
            >Si cancelas esta solicitud de acceso de personal, ya no podrá ser modificada
            ni enviada nuevamente. ¿Estás seguro de que deseas continuar?</span
          >

          <v-col sm="12" lg="12">
            <v-form class="" v-model="isFormCancellValid" ref="form_cancell">
              <v-textarea
                v-model="motivo_cancell"
                outlined
                label="Motivo de cancelación"
                :rules="[rules.required]"
                required
              ></v-textarea>
              <v-btn
                :loading="loading"
                color="primary"
                class=""
                :disabled="!isFormCancellValid"
                @click="cancellSolicitud()"
                block
              >
                Cancelar solicitud
              </v-btn>
            </v-form>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDocumentos" max-width="1000px">
      <v-card>
        <!-- Título -->
        <v-card-title class="headline d-flex justify-space-between">
          <span>Documentación </span>
          <v-btn icon @click="dialogDocumentos = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Cuerpo -->
        <v-card-text>
          <v-row>
            <!-- Lista de enlaces a la izquierda -->
            <v-col cols="12" md="4">
              <v-list>
                <!-- Verifica si hay documentos -->
                <v-list-item-group v-if="documentos_viz.length > 0">
                  <!-- Itera sobre los documentos -->
                  <v-list-item
                    v-for="(file, index) in documentos_viz"
                    :key="index"
                    class="cursor-pointer hover:bg-light-blue"
                    @click="viewPdf(file)"
                  >
                    <!-- Icono inicial -->
                    <v-list-item-icon>
                      <v-icon color="blue">description</v-icon>
                    </v-list-item-icon>

                    <!-- Contenido del ítem -->
                    <v-list-item-content>
                      <v-list-item-title class="text-truncate">
                        Archivo - {{ index + 1 }}
                      </v-list-item-title>
                      <v-list-item-subtitle> Documento PDF </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>

                <!-- Si no hay documentos -->
                <v-list-item v-else>
                  <v-list-item-content>
                    <v-list-item-title class="text-center text-grey">
                      No hay archivos disponibles.
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <!-- Visor de PDF a la derecha -->
            <v-col cols="12" md="8">
              <div v-if="pdfLink">
                <iframe
                  :src="pdfLink"
                  width="100%"
                  height="700px"
                  style="border: none"
                ></iframe>
              </div>
              <div v-else class="text-center">Selecciona un documento para verlo</div>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Acciones -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAut1" max-width="500px">
      <v-card>
        <v-toolbar color="primary" dark>Autorizar solicitud de acceso</v-toolbar>

        <v-container>
          <v-row>
            <v-col cols="12">
              <p style="font-size: 14px; color: gray">
                Se ha recibido la solicitud
                <strong>#{{ itemSelected.folio }}</strong> para que ingrese personal a la
                embarcación
                <strong>{{
                  itemSelected.embarcacion && itemSelected.embarcacion.nombre
                    ? itemSelected.embarcacion.nombre
                    : "N/A"
                }}</strong>
                en el muelle <strong>{{ itemSelected.muelle }}</strong
                >. Por favor, confirme si autoriza este acceso.
              </p>
              <span style="font-size: 12px">Pasajeros:</span>
              <ul>
                <li
                  style="font-size: 12px"
                  v-for="(item, index) in itemSelected.pasajeros"
                  :key="index"
                >
                  {{ item.nombre_completo }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogAut1 = false">Salir</v-btn>
          <v-btn color="blue darken-1" :loading="loading" text @click="activar"
            >Autorizar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAut2" max-width="500px">
      <v-card>
        <v-toolbar color="primary" dark>Autorizar solicitud de acceso</v-toolbar>

        <v-container>
          <v-row>
            <v-col cols="12">
              <p style="font-size: 14px; color: gray">
                Se ha recibido la solicitud
                <strong>#{{ itemSelected.folio }}</strong> para que ingrese personal a la
                embarcación
                <strong>{{
                  itemSelected.embarcacion && itemSelected.embarcacion.nombre
                    ? itemSelected.embarcacion.nombre
                    : "N/A"
                }}</strong>
                en el muelle <strong>{{ itemSelected.muelle }}</strong
                >. Por favor, confirme si autoriza este acceso.
              </p>
              <span style="font-size: 12px">Pasajeros:</span>
              <ul>
                <li
                  style="font-size: 12px"
                  v-for="(item, index) in itemSelected.pasajeros"
                  :key="index"
                >
                  {{ item.nombre_completo }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogAut2 = false">Salir</v-btn>
          <v-btn color="blue darken-1" :loading="loading" text @click="autorizarOpib"
            >Autorizar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogNuevaSolicitud"
      transition="dialog-bottom-transition"
      max-width="1200"
    >
      <v-card>
        <v-toolbar color="primary" dark>{{
          editedIndex
            ? "Editar solicitud de Acceso a personal"
            : "Guardar solicitud de Acceso a personal"
        }}</v-toolbar>
        <v-card-text>
          <div class="pa-8">
            <v-stepper v-model="e1">
              <loading-overlay :overlay="loading"></loading-overlay>

              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1">
                  Datos de la solicitud
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 2" step="2">
                  Lista del personal
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 3" step="3"> Detalles </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <div>
                    <!-- TODO: Agrega una seccion con un input y  un boton para buscar por numero de folio -->
                    <br />
                    <v-row>
                      <v-col cols="4" class="text--secondary">
                        <v-text-field
                          v-model="buscarFolio"
                          outlined
                          dense
                          label="Ej. 0001/FR/PES/01012025"
                          hint="Este campo es para autocompletar el formulario"
                          persistent-hint
                        ></v-text-field>
                      </v-col>

                      <v-col cols="auto">
                        <v-btn color="primary" @click="buscar_folio" style="height: 40px">
                          Buscar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row no-gutters align="center">
                    <v-flex xs12 sm12 lg12 x12>
                      <v-radio-group v-model="tipo" row>
                        <v-radio value="Prestador de Servicios">
                          <template v-slot:label>
                            <div class="text-sm">
                              <strong> Prestador de servicios</strong>
                            </div>
                          </template></v-radio
                        >
                        <v-radio value="Cesionario">
                          <template v-slot:label>
                            <div class="text-sm">
                              <strong>Cesionario</strong>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="Contratista">
                          <template v-slot:label>
                            <div class="text-sm">
                              <strong>Contratista</strong>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="Armador">
                          <template v-slot:label>
                            <div class="text-sm"><strong>Armador</strong></div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-row no-gutters align="center">
                      <v-col cols="6" class="text--secondary">
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="date"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mr-2"
                              outlined
                              dense
                              label="Vigencia del folio"
                              v-model="dateRangeText"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="fechas" range scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false"
                              >Cancel</v-btn
                            >
                            <v-btn text color="primary" @click="$refs.dialog.save(date)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>

                      <v-col cols="6" class="text--secondary">
                        <v-autocomplete
                          outlined
                          dense
                          :items="muelles"
                          v-on="on"
                          label="Muelle"
                          v-model="muelle"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6" class="text--secondary">
                        <v-autocomplete
                          class="mr-2"
                          outlined
                          dense
                          v-model="embarcacion"
                          label="Embarcación"
                          :items="embarcaciones"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6" class="text--secondary">
                        <v-text-field
                          outlined
                          label="Compañia del servicio"
                          dense
                          v-model="compania"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="text--secondary">
                        <v-checkbox
                          v-model="operacion"
                          value="Embarque"
                          label="Embarque"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="operacion"
                          value="Desembarque"
                          label="Desembarque"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="6" class="text--secondary">
                        <v-checkbox
                          v-model="material_muelle"
                          value="ingreso"
                          label="Ingreso de material o equipo"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="material_muelle"
                          value="retiro"
                          label="Retiro de material o equipo"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-row>
                  <v-btn color="primary" @click="checkDataStepper(1)"> Continuar </v-btn>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <div class="my-5">
                    <v-row class="mb-4" justify="center" align="center">
                      <v-col cols="auto">
                        <v-btn
                          class="mr-2"
                          small
                          color="primary"
                          @click="agregarDetalle()"
                        >
                          <v-icon left dark>person_add</v-icon>
                          Agregar pasajero
                        </v-btn>
                      </v-col>

                      <v-col cols="auto">
                        <input
                          ref="csv"
                          type="file"
                          name="csv"
                          class="d-none"
                          accept=".csv"
                          id="csv"
                          @change="csvfile"
                        />

                        <v-menu
                          :nudge-width="10"
                          rounded="lg"
                          offset-y
                          :close-on-content-click="true"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ml-2"
                              small
                              color="secondary"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon left dark>file_upload</v-icon>
                              Importar plantilla de pasajeros
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item link>
                              <v-list-item-content>
                                <v-list-item-title>
                                  <a
                                    href="plantilla.csv"
                                    download="plantilla.csv"
                                    style="color: black"
                                    class="text-decoration-none"
                                  >
                                    Descargar plantilla
                                  </a>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item link @click="triggerFileInput">
                              <v-list-item-content>
                                <v-list-item-title>Importar plantilla</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-data-table
                          :headers="cabeceraDetalles"
                          :items="pasajeros"
                          dense
                          class="elevation-1 no-border-rows"
                        >
                          <template v-slot:item.borrar="{ item }">
                            <v-icon
                              small
                              @click="eliminarPasajero(pasajeros, item)"
                              color="red"
                            >
                              delete
                            </v-icon>
                          </template>

                          <template v-slot:item.destino="{ item }">
                            <v-text-field
                              v-model="item.destino"
                              dense
                              solo
                              flat
                              hide-details
                              class="text-xs-center"
                            ></v-text-field>
                          </template>
                          <template v-slot:item.compania="{ item }">
                            <v-text-field
                              v-model="item.compania"
                              dense
                              hide-details
                              solo
                              flat
                              class="text-xs-center"
                            ></v-text-field>
                          </template>
                          <template v-slot:item.nombre_completo="{ item }">
                            <v-text-field
                              v-model="item.nombre_completo"
                              dense
                              hide-details
                              solo
                              flat
                              class="text-xs-center"
                            ></v-text-field>
                          </template>

                          <template v-slot:item.libreta_mar="{ item }">
                            <v-text-field
                              v-model="item.libreta_mar"
                              dense
                              hide-details
                              solo
                              flat
                              class="text-xs-center"
                            ></v-text-field>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>

                    <div class="my-4">
                      <v-btn small color="primary" @click="checkDataStepper(2)">
                        Continuar
                      </v-btn>

                      <v-btn class="mx-3" small @click="e1 = 1" text> Regresar </v-btn>
                    </div>
                  </div>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <div class="">
                    <v-col cols="12" sm="12" md="12">
                      Adjunte los archivos de identificación oficial conforme a la lista
                      de pasajeros :
                      <br />
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        v-model="file"
                        small-chips
                        multiple
                        dense
                        :rules="fileRules"
                        @change="validateFileSize"
                        show-size
                        accept=".pdf"
                        outlined
                      ></v-file-input>
                    </v-col>
                  </div>
                  <v-flex xs12 sm2 md12 lg12 xl12 v-if="editedIndex">
                    <template>
                      <v-row
                        style="margin-top: -15px"
                        v-for="(item, index) in adjuntosLista"
                      >
                        <v-col lg="2" sm="2" md="2">
                          <v-btn class="ma-2" dark small @click="descargarAdjuntos(item)">
                            <v-icon dark left> file_download </v-icon>Documento
                            {{ index + 1 }}
                          </v-btn>
                        </v-col>
                        <v-col lg="2" sm="2" md="2">
                          <v-btn
                            class="ma-2"
                            text
                            icon
                            @click="eliminarAdjunto(adjuntosLista, item)"
                            color="red"
                          >
                            <v-icon>backspace</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 x12>
                    <v-textarea
                      v-model="detalles"
                      outlined
                      label="Motivo de la visita"
                    ></v-textarea>
                  </v-flex>

                  <v-flex xs12 sm2 md12 lg12 xl12>
                    <v-btn class="ma-2" @click="guardar()" small color="primary"
                      >Guardar</v-btn
                    >
                    <v-btn class="ma-2" @click="e1 = 2" small>Regresar</v-btn>
                  </v-flex>
                </v-stepper-content>
                <v-stepper-content step="4">
                  <div class="my-5">
                    <v-btn color="primary" @click="e1 = 5"> Continuar </v-btn>

                    <v-btn @click="e1 = 3" text> Regresar </v-btn>
                  </div>
                </v-stepper-content>
                <v-stepper-content step="5">
                  <v-btn class="ma-2" small outlined color="indigo">{{
                    editedIndex ? "Editar" : "Guardar"
                  }}</v-btn>

                  <v-btn @click="e1 = 4" text> Regresar </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </div>
          <div class="text-center ma-2">
            <v-snackbar
              v-model="snackbar"
              absolute
              bottom
              right
              timeout="2000"
              color="red"
            >
              {{ text }}

              <template v-slot:action="{ attrs }">
                <v-btn color="dark" text v-bind="attrs" @click="snackbar = false">
                  Cerrar
                </v-btn>
              </template>
            </v-snackbar>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogNuevaSolicitud = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="750px">
      <v-card>
        <v-card-title>
          <span>Alta de pasajeros</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field v-model="nombreP" label="Nombre completo"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field v-model="companiaP" label="Compania"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Salir</v-btn>
          <v-btn color="blue darken-1" text @click="guardarPasajero">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex>
      <div class="pb-10 d-flex align-center justify-space-between">
        <div>
          <h2>Solicitudes de acceso de personal</h2>
          <span style="font-size: 13px; color: gray">
            Solicita y gestiona pases de acceso al muelle para personal.
          </span>
        </div>

        <v-btn
          v-if="
            usuario_log.rol == 'Agencia' ||
            usuario_log.rol == 'root' ||
            usuario_log.rol == 'Autorizador directo'
          "
          @click="mostrarNuevo()"
          >Nueva Solicitud</v-btn
        >
      </div>

      <v-layout>
        <v-flex>
          <material-card
            icon="engineering"
            title="Solicitudes creadas "
            class="px-5 py-3"
          >
            <v-layout>
              <v-flex>
                <v-row>
                  <v-col cols="12">
                    <div class="input-filter">
                      <v-menu offset-y :nudge-width="150">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            class="mb-2"
                          >
                            <v-icon>filter_list</v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-item dense @click="showFilterFolio = true">
                            <v-list-item-title>
                              <span class="texto">Folio</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item dense @click="showFilterEmbarcacion = true">
                            <v-list-item-title>
                              <span class="texto">Embarcación</span>
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="showFilterTipo = true">
                            <v-list-item-title>
                              <span class="texto">Tipo</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item dense @click="showFilterMuelle = true">
                            <v-list-item-title>
                              <span class="texto">Muelle</span>
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="showFilterEstatus = true">
                            <v-list-item-title>
                              <span class="texto">Estatus</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item dense @click="showFilterFecha = true">
                            <v-list-item-title>
                              <span class="texto">Fecha</span></v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <div class="text-center"></div>
                      <div v-if="arr.length == 0" class="filter-label">
                        <span>Ningun filtro seleccionado...</span>
                      </div>
                      <div v-else class="filter-chips">
                        <v-chip
                          class="ml-2"
                          v-for="(item, index) in arr"
                          :key="index"
                          close
                          close-icon="cancel"
                          @click:close="eliminarFiltro(index)"
                          color="primary"
                          small
                        >
                          {{ item.label }}
                        </v-chip>
                      </div>
                      <v-dialog
                        v-model="showFilterFolio"
                        transition="dialog-bottom-transition"
                        max-width="350"
                      >
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por folio</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-text-field
                              v-model="folio_filter"
                              outlined
                              dense
                              prefix="CG-"
                              label="Ingrese el folio de la solicitud"
                            ></v-text-field>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('folio')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog
                        v-model="showFilterEmbarcacion"
                        transition="dialog-bottom-transition"
                        max-width="350"
                      >
                        <v-card>
                          <v-toolbar color="primary" dark
                            >Busqueda por Embarcación</v-toolbar
                          >
                          <v-card-text class="mt-10">
                            <v-autocomplete
                              return-object
                              v-model="embarcacion_filter"
                              outlined
                              :items="embarcaciones"
                              dense
                              label="Ingrese la embarcación"
                            ></v-autocomplete>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('embarcacion')"
                              >Aplicar</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog
                        v-model="showFilterMuelle"
                        transition="dialog-bottom-transition"
                        max-width="350"
                      >
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por muelle</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-autocomplete
                              label="Muelle"
                              :items="muelles"
                              v-model="muelle_filter"
                              hide-details
                              dense
                              outlined
                            ></v-autocomplete>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('muelle')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog
                        v-model="showFilterTipo"
                        transition="dialog-bottom-transition"
                        max-width="350"
                      >
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por tipo</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-autocomplete
                              label="Tipo"
                              :items="[
                                'Prestador de Servicios',
                                'Cesionario',
                                'Contratista',
                                'Armador',
                              ]"
                              v-model="tipo_filter"
                              hide-details
                              dense
                              outlined
                            ></v-autocomplete>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('tipo')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog
                        v-model="showFilterEstatus"
                        transition="dialog-bottom-transition"
                        max-width="350"
                      >
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por estatus</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-autocomplete
                              v-if="usuario_log.rol == 'Agencia'"
                              label="Estatus"
                              return-object
                              :items="[
                                { text: 'En proceso', value: '0' },
                                { text: 'Aprobado', value: '2' },
                              ]"
                              hide-details
                              dense
                              v-model="estatus_filter"
                              outlined
                            ></v-autocomplete>
                            <v-autocomplete
                              v-else
                              label="Estatus"
                              return-object
                              :items="[
                                { text: 'En proceso', value: '0' },
                                { text: 'Aut-1', value: '1' },
                                { text: 'Aprobado', value: '2' },
                              ]"
                              hide-details
                              dense
                              v-model="estatus_filter"
                              outlined
                            ></v-autocomplete>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('estado')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog
                        v-model="showFilterFecha"
                        transition="dialog-bottom-transition"
                        max-width="350"
                      >
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por fecha</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-text-field
                              v-model="fecha_inicio_filter"
                              type="date"
                              outlined
                              dense
                              label="Inicio"
                            ></v-text-field>
                            <v-text-field
                              v-model="fecha_fin_filter"
                              type="date"
                              outlined
                              dense
                              label="Fin"
                            ></v-text-field>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('createdAt')"
                              >Aplicar</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
            <v-simple-table class="rounded-table mt-3" style="" dense>
              <thead class="rounded-table" style="background-color: rgb(124, 28, 64)">
                <tr style="border-radius: 15px">
                  <th class="white--text">Folio</th>
                  <th class="white--text">Embarcación</th>
                  <th class="white--text">Procedencia</th>
                  <th class="white--text">Tipo</th>
                  <th class="white--text">Estatus</th>
                  <th class="white--text">Pasajeros</th>
                  <th class="text-right white--text">Opciones</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, index) in cambiosGuardia" :key="index">
                  <td style="font-size: 10px; font-weight: bold">
                    {{ formatFolio(item.folio, item.muelle, item.createdAt) }}
                  </td>
                  <td style="font-size: 12px; color: gray; font-weight: bold">
                    <span v-if="item.embarcacion">
                      {{ item.embarcacion.nombre }}
                    </span>
                    <span v-else> N/A </span>
                  </td>
                  <td style="font-size: 12px; color: gray; font-weight: bold">
                    {{ item.muelle }}
                  </td>
                  <td style="font-size: 12px; color: gray; font-weight: bold">
                    {{ item.tipo }}
                  </td>
                  <td>
                    <v-chip
                      small
                      class="ma-2"
                      label
                      outlined
                      color="orange"
                      v-if="
                        item.estado == 0 ||
                        (item.estado == 1 && usuario_log.rol == 'Agencia')
                      "
                    >
                      <v-avatar left>
                        <v-icon small>restore</v-icon>
                      </v-avatar>
                      En proceso de autorización
                    </v-chip>

                    <v-chip
                      small
                      class="ma-2"
                      label
                      outlined
                      color=""
                      v-if="
                        item.estado == 1 &&
                        (usuario_log.rol == 'Administrador' ||
                          usuario_log.rol == 'OPIP' ||
                          usuario_log.rol == 'Operaciones' ||
                          usuario_log.rol == 'root')
                      "
                    >
                      <v-avatar left>
                        <v-icon small>restore</v-icon>
                      </v-avatar>
                      Autorizado por el OPIP
                    </v-chip>

                    <v-chip
                      small
                      class="ma-2"
                      color="green"
                      label
                      outlined
                      v-if="item.estado == 2"
                    >
                      <v-avatar left>
                        <v-icon small>done</v-icon>
                      </v-avatar>
                      Aprobado
                    </v-chip>

                    <v-chip
                      small
                      class="ma-2"
                      color="black"
                      text-color="white"
                      v-if="item.estado == 4"
                    >
                      <v-avatar left>
                        <v-icon small>verified</v-icon>
                      </v-avatar>
                      Servicio realizado
                    </v-chip>
                    <v-tooltip top v-if="item.estado == 5">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          small
                          color="red"
                          label
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          class="ma-2"
                        >
                          <v-avatar left>
                            <v-icon small>delete</v-icon>
                          </v-avatar>
                          Cancelado
                        </v-chip>
                      </template>
                      <span>{{ item.motivo_cancelacion }}</span>
                    </v-tooltip>
                  </td>
                  <td style="font-size: 12px; color: gray; font-weight: bold">
                    {{ item.pasajeros.length }} pasajeros
                  </td>
                  <td class="text-right">
                    <v-menu bottom left rounded="lg">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>more_horiz</v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          v-if="item.estado == '0' && usuario_log.rol == 'Agencia'"
                          @click="editItem(item)"
                          link
                        >
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="mostrarComprobante(item)" link>
                          <v-list-item-title>Imprimir documento</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item @click="generarPdfBackend(item)" link>
                          <v-list-item-title>Imprimir documento</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="usuario_log.rol == 'OPIP' && item.estado == '0'"
                          @click="mostrarDialogAut1(item)"
                          link
                        >
                          <v-list-item-title>Aprobar solicitud</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                          v-if="usuario_log.rol == 'Operaciones' && item.estado == '1'"
                          @click="mostrarDialogAut2(item)"
                          link
                        >
                          <v-list-item-title>Aprobar solicitud</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                          v-if="item.estado == '2'"
                          @click="imprimirPaseAcceso(item)"
                          link
                        >
                          <v-list-item-title>Imprimir pase de acceso</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="mostrarDocumentacion(item)" link>
                          <v-list-item-title>Mostrar documentación</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            (usuario_log.rol == 'Operaciones' ||
                              usuario_log.rol == 'OPIP') &&
                            item.estado != 5
                          "
                          @click="mostrarDialogCancel(item)"
                          link
                        >
                          <v-list-item-title>Cancelar solicitud</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <!-- <v-icon
                    small
                    v-if="item.estado == 0"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    edit
                  </v-icon>
                  <v-icon v-if="item.estado == 2" class="mr-2" @click="editItem(item)">
                    edit
                  </v-icon>

                  <v-icon
                    v-if="item.estado"
                    class="mr-2"
                    @click="mostrarComprobante(item)"
                  >
                    text_snippet
                  </v-icon> -->
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </material-card>

          <template>
            <div class="text-center mt-3">
              <v-pagination
                v-model="page"
                @input="listar()"
                :length="totalPages"
                :total-visible="7"
              ></v-pagination>
            </div>
          </template>

          <!-- <template>
            <div class="text-center mt-3">
              <v-pagination
                v-model="page"
                @input="listar()"
                :length="totalPages"
                :total-visible="7"
              ></v-pagination>
            </div>
          </template> -->
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import emailjs from "emailjs-com";
import S3 from "aws-s3";
import swal from "sweetalert";
import { required, email, minLength } from "vuelidate/lib/validators";
import { uploadDocument } from "../../helpers/handleUploadsDocument";
import MaterialCard from "../components/MaterialCard.vue";
import LoadingOverlay from "../components/Loading.vue";
import autoTable from "jspdf-autotable";
import { generateAccesPersonal } from "./pdf/pase_acceso_personal";
import { imgEncabezado } from "../../helpers/imgBase64.js";
import QRCode from "qrcode";
import Papa from "papaparse"; // Asegúrate de tener papaparse instalado
import {
  generarPdfCG,
  cancelCambioGuardia,
  buscarFolioCambioGuardia,
} from "../../api/endpoints";

export default {
  components: {
    MaterialCard,
    LoadingOverlay,
  },
  icons: {
    iconfont: "fa4",
  },

  validations: {
    tipo: {
      required,
    },

    muelle: {
      required,
    },

    embarcacion: {
      required,
    },
    compania: {
      required,
    },
    pasajeros: {
      required,
    },

    detalles: {
      required,
      minLength: minLength(10),
    },
    file: {
      required,
    },
  },

  data() {
    return {
      dialogDocumentos: false,
      documentos_viz: [],
      pdfLink: null,
      buscarFolio: "",
      //filtros
      showFilterFolio: false,
      showFilterEmbarcacion: false,
      showFilterMuelle: false,
      showFilterEstatus: false,
      showFilterTipo: false,
      showFilterFecha: false,
      folio_filter: "",
      embarcacion_filter: null,
      muelle_filter: "",
      estatus_filter: null,
      fecha_inicio_filter: "",
      fecha_fin_filter: "",
      tipo_filter: "",
      arr: [],
      headers: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Fecha", value: "fecha", sortable: true },
        { text: "Folio", value: "folio", sortable: false },
        { text: "Embarcacion", value: "embarcacion.nombre", sortable: false },
        { text: "Estatus", value: "estado", sortable: true },
        { text: "Pase de Lista", value: "paseLista", sortable: true },
        { text: "Adjuntos", value: "adjuntos", sortable: false },
        { text: "Lista de Pasajeros", value: "list_p", sortable: false },
      ],
      editedIndex: false,
      maxSizeInBytes: 20 * 1024 * 1024, // 20 MB
      fileRules: [
        (file) => this.validateRequired(file) || "",
        (file) =>
          this.isTotalFileSizeValid(file) || "El tamaño total debe ser menor de 20 MB",
      ],
      _id: "",
      e1: 1,
      dialogAut2: false,
      snackbar: false,
      page: 1,
      totalPages: 0,
      itemSelected: [],
      dialogAut1: false,
      text: "",
      embarcacion: "",
      embarcaciones: [],
      dialogNuevaSolicitud: false,
      dialog: "",
      search: "",
      adjuntosLista: [],
      cambiosGuardia: [],
      paseLista: "",
      muelles: [
        "MUELLE FISCAL",
        "MUELLE PESCADORES FRONTERA",
        "CENTRO DE REPARACIONES NAVALES",
        "ESPADAÑAL",
        "MUELLE PESCADORES CHILTEPEC",
        "SANCHEZ MAGALLANES",
        "MUELLE DE TANQUES",
        "MUELLE COSUGO",
        "MUELLE PRIVADO CARLOS DAVID",
      ],
      muelle: "",
      vehiculos: [],
      cargo: "",
      operacion2: [],
      nombreP: "",
      apellidoPP: "",
      apellidoMP: "",
      companiaP: "",
      rfcP: "",
      usuario_log: [],
      puestoP: "",
      nssP: "",
      alert: false,
      material_muelle: [],
      nombreCompleto: "",
      agencias: [],
      nombre: "",
      loading: false,
      compania: "",
      on: "",
      menu: "",
      tipoDeEntradas: false,
      companias: [],
      barcodeValue: "",
      operacion: [],
      folioOtraSolicitud: "",
      agencia2: "",
      tipoServicio: "",
      agenciasUsuario: [],
      cabeceraDetalles: [
        { text: "Borrar", value: "borrar", sortable: false },
        { text: "Nombre completo", value: "nombre_completo", sortable: false },
        { text: "Compañia", value: "compania", sortable: false },
        { text: "Libreta de Mar", value: "libreta_mar", sortable: false },
        { text: "Destino/Procedencia", value: "destino", sortable: false },
      ],
      pasajeros: [],
      panel: [0, 1, 2, 3],
      verNuevo: 0,
      usuario: "",
      solicitud: "",
      passenger: [],
      texto: [],
      cabeceraPasajeros: [
        { text: "Seleccion", value: "action", sortable: false },
        { text: "RFC", value: "rfc", sortable: true },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Apellido Paterno", value: "apellidoPaterno", sortable: true },
        { text: "Apellido Materno", value: "apellidoMaterno", sortable: true },

        { text: "Numero de Seguro Social", value: "nss", sortable: false },
      ],
      fechas: [],
      submited: false,
      fecha_solicitud: "",
      agencia: "",
      fecha: "",
      extensionAdjunto: [],
      numbersRandomAdjunto: [],
      nombreAdjuntos: [],
      adjunto: "",
      errorRfc: null,
      alert: "",
      folio: "",
      fecha: "",
      pasajerosList: [],
      dialogs: false,
      motivo_cancelacion: "",

      estado: "",
      estatus: "Embarque",
      emb_des: ["Embarque", "Desembarque"],
      tipoServicio: "",
      detalles: "",
      rfc: "",
      puesto: "",
      valida: 0,
      file: "",
      ingreso_mat: false,
      retiro_mat: false,
      tipoServ: "CAM",
      tipo: "",
      fecha: null,
      date: "",
      modal: false,
      validaMensaje: [],
      aprobacionAmls: "",
      aprobacionApi: "",
      adModal: 0,
      comprobanteModal: 0,
      comprobanteModalPasajero: 0,
      adAccion: 0,
      adNombre: "",
      adjunto: "",
      adId: "",
      dialogCancell: false,
      motivo_cancell: "",
      isFormCancellValid: false,
      rules: {
        required: (value) => !!value || "Este campo es requerido",
      },
      company_logo: {
        w: 460,
        h: 60,
      },
      imgData:
        "data:image/png;base64,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",
    };
  },
  computed: {
    config() {
      return {
        bucketName: "sam-amls",
        dirName: "cg" /* optional */,
        region: "us-west-1",
        accessKeyId: "AKIAVFDVDRT4HCGVWS6A",
        secretAccessKey: "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",
        s3Url: this.baseUrl,
      };
    },
    baseUrl() {
      return "https://sam-amls.s3-us-west-1.amazonaws.com";
    },
    S3Client() {
      return new S3(this.config);
    },
    newFileName() {
      return Math.random().toString().slice(2);
    },

    url() {
      return `${this.baseUrl}/${"cg"}/`;
    },

    formTitle() {
      return this.editedIndex === -1 ? "Nueva Solicitud" : "Editar Solicitud";
    },
    dateRangeText() {
      return this.fechas.join(" al ");
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.listarAgencia(this.$store.state.usuario.agencia);
    this.usuario_log = this.$store.state.usuario;

    this.selectEmbarcaciones();
    this.emailIn();

    this.selectPasajeros();
  },

  methods: {
    validateRequired(file) {
      return file && file.length > 0; // Verifica si hay al menos un archivo seleccionado
    },
    isTotalFileSizeValid(file) {
      if (!file || file.length === 0) return true; // No mostrar error si no hay archivos

      const totalSize = file.reduce((acc, file) => acc + file.size, 0); // Sumar los tamaños de todos los archivos
      return totalSize <= this.maxSizeInBytes; // Comparar con el tamaño máximo permitido
    },
    // Verifica el tamaño total y limpia la selección si supera el límite
    validateFileSize(file) {
      console.log(file);
      this.isTotalFileSizeValid(file);
      if (file && !this.isTotalFileSizeValid(file)) {
        this.file = []; // Limpia la selección de archivos
        this.$emit("input", []); // Limpia los archivos seleccionados
        this.$notify({
          title: "!Alerta!",
          text: "Los archivos adjuntos deben pesar menos de 20mb",
          type: "warning",
        });
      }
    },
    async crearPDF() {
      var doc = new jsPDF("p", "pt", "a4");
      var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      var startX = 40;
      var startY = 10;

      //QR
      const qrText = this._id;
      const qrCodeDataURL = await QRCode.toDataURL(qrText, { width: 228 });

      if (qrCodeDataURL) {
        const qrWidth = 60; // Ancho del QR
        const qrHeight = 60; // Altura del QR
        const qrXPosition = 510; // Posiciona el QR en el centro horizontal
        const qrYPosition = 30; // Posición vertical más baja

        doc.addImage(qrCodeDataURL, "PNG", qrXPosition, qrYPosition, qrWidth, qrHeight);
      } else {
        console.error("Error al generar el código QR");
      }

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");

      doc.text("Solicitud de Entrada", pageWidth / 2, 100, { align: "center" });
      doc.text("CG-" + this.folio, pageWidth / 2, 110, { align: "center" });
      doc.addImage(
        imgEncabezado,
        "JPEG",
        startX,
        (startY += 20),
        this.company_logo.w,
        this.company_logo.h
      );
      doc.setFont("helvetica", "normal");

      //doc.setFontType("normal");
      doc.setFontSize(8);

      doc.text("Frontera, Tab. a: " + this.fecha, 365, 125);
      //doc.setFontType("bold");
      // if (this.solicitud) {
      //   doc.text("Solicitud de " + this.solicitud, 365, 175);
      // }
      //doc.setFontType("normal");
      doc.setFontSize(8);
      doc.text(
        "De conformidad y en cumplimiento a lo estipulado en las Reglas de Operación de la APITAB en su capitulo IV.- Acceso y vialidades del Puerto ",
        40,
        155,
        { align: "justify" }
      );
      doc.text(
        "Regla 19, 20, 21 y 22 y Código Internacional de Protección a Buques e Instalaciones Portuarias.",
        40,
        165,
        { align: "justify" }
      );
      doc.text(
        "Solicito la ENTRADA a las areas del recinto portuario concesionadas a la administracion portuaria integral de Tabasco S.A. de C.V con Fecha",
        40,
        175,
        { align: "justify" }
      );
      doc.text(
        this.fecha_solicitud +
          " del personal y vehiculos que a continuacion se enlistan.",
        40,
        185,
        { align: "justify" }
      );

      //Datos de Agencia

      //doc.setFontType("normal");
      doc.text("Nombre del Solicitante", 40, 210); // Restar 40 a 250
      doc.line(170, 213, 530, 213); // Restar 40 a 253
      doc.text("Cargo", 40, 225); // Restar 40 a 265
      doc.line(170, 228, 530, 228); // Restar 40 a 268
      doc.text("Agencia Naviera", 40, 240); // Restar 40 a 280
      doc.line(170, 243, 530, 243); // Restar 40 a 283
      doc.text(this.usuario[0].nombre, 180, 210); // Restar 40 a 250

      //
      if (this.usuario[0].cargo == null) {
        doc.text(".", 180, 225); // Restar 40 a 265
      } else {
        doc.text(this.usuario[0].cargo, 180, 225); // Restar 40 a 265
      }
      doc.text(this.agenciaDatos.nombre, 180, 240); // Restar 40 a 280

      doc.text("Contratista", 40, 260); // Restar 40 a 300
      doc.text("Armador", 180, 260); // Restar 40 a 300
      doc.text("Prestador de Servicios", 290, 260); // Restar 40 a 300
      doc.text("Cesionario", 430, 260); // Restar 40 a 300

      if (this.tipo == "Contratista") {
        doc.rect(130, 252, 10, 10, "F"); // Restar 40 a 292
        doc.rect(250, 252, 10, 10); // Restar 40 a 292
        doc.rect(390, 252, 10, 10); // Restar 40 a 292
        doc.rect(500, 252, 10, 10); // Restar 40 a 292
      } else if (this.tipo == "Armador") {
        doc.rect(130, 252, 10, 10); // Restar 40 a 292
        doc.rect(250, 252, 10, 10, "F"); // Restar 40 a 292
        doc.rect(390, 252, 10, 10); // Restar 40 a 292
        doc.rect(500, 252, 10, 10); // Restar 40 a 292
      }
      if (this.tipo == "Prestador de Servicios") {
        doc.rect(130, 252, 10, 10); // Restar 40 a 292
        doc.rect(250, 252, 10, 10); // Restar 40 a 292
        doc.rect(390, 252, 10, 10, "F"); // Restar 40 a 292
        doc.rect(500, 252, 10, 10); // Restar 40 a 292
      } else if (this.tipo == "Cesionario") {
        doc.rect(130, 252, 10, 10); // Restar 40 a 292
        doc.rect(250, 252, 10, 10); // Restar 40 a 292
        doc.rect(390, 252, 10, 10); // Restar 40 a 292
        doc.rect(500, 252, 10, 10, "F"); // Restar 40 a 292
      }

      //Caracteristicas de la Embarcacion
      doc.setFillColor(196, 196, 196);
      doc.rect(40, 270, 495, 10, "F"); // Restar 40 a 310
      //doc.setFontType("bold");
      doc.text("Caracteristicas de la Embarcación", 42, 278); // Restar 40 a 318
      //doc.setFontType("normal");
      doc.text("Nombre de la Embarcación", 40, 300); // Restar 40 a 340
      doc.text(this.embarcacion.nombre, 173, 300); // Restar 40 a 340
      doc.line(170, 303, 530, 303); // Restar 40 a 343
      doc.text("Al servicio de la compañia", 40, 315); // Restar 40 a 355
      doc.text(this.compania, 173, 315); // Restar 40 a 355
      doc.line(170, 318, 530, 318); // Restar 40 a 358
      doc.text("Tipo", 40, 330); // Restar 40 a 370
      doc.text(this.embarcacion.tipo, 63, 330); // Restar 40 a 370
      doc.line(60, 333, 140, 333); // Restar 40 a 373
      doc.text("Bandera", 150, 330); // Restar 40 a 370
      doc.text(this.embarcacion.bandera, 188, 330); // Restar 40 a 370
      doc.line(185, 333, 265, 333); // Restar 40 a 373
      doc.text("T.R.B.", 275, 330); // Restar 40 a 370
      doc.text(this.embarcacion.tbr.toString(), 303, 330); // Restar 40 a 370
      doc.line(300, 333, 350, 333); // Restar 40 a 373
      doc.text("Eslora", 360, 330); // Restar 40 a 370
      doc.text(this.embarcacion.eslora.toString(), 393, 330); // Restar 40 a 370
      doc.line(390, 333, 440, 333); // Restar 40 a 373
      doc.text("Manga", 450, 330); // Restar 40 a 370
      doc.text(this.embarcacion.manga.toString(), 483, 330); // Restar 40 a 370
      doc.line(480, 333, 530, 333); // Restar 40 a 373

      doc.setFillColor(196, 196, 196);
      doc.rect(39, 350, 516, 10, "F"); // Restar 40 a 390
      //doc.setFontType("bold");
      doc.text("Lista de Personal", 42, 357);

      //Tabla de Pasajeros
      const cols = ["Nombre completo ", "Compañia"];

      var rows = [];

      const data = this.pasajeros.map((x) => [x.nombre_completo, x.compania]);

      autoTable(doc, {
        theme: "grid",
        columns: cols,
        body: data,
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [12, 1, 1],
          fontSize: 8,
        },
        styles: {
          overflow: "linebreak",
          lineWidth: 1,
          lineColor: [0, 0, 0],
          fontSize: 8,
        },
        startY: 360, // Restar 40 a 400
        showHead: "firstPage",
      });

      if (doc.lastAutoTable.finalY >= 780) {
        doc.addPage();
        doc.lastAutoTable.finalY = 50;
      }
      doc.text("Ingreso de material o equipo", 40, doc.lastAutoTable.finalY + 30);
      doc.text("Retiro de material o equipo", 290, doc.lastAutoTable.finalY + 30);

      if (this.solicitud == "Ingreso y Retiro") {
        doc.rect(200, doc.lastAutoTable.finalY + 22, 10, 10, "F");
        doc.rect(450, doc.lastAutoTable.finalY + 22, 10, 10, "F");
      } else if (this.solicitud == "Ingreso") {
        doc.rect(200, doc.lastAutoTable.finalY + 22, 10, 10, "F");
        doc.rect(450, doc.lastAutoTable.finalY + 22, 10, 10);
      } else if (this.solicitud == "Retiro") {
        doc.rect(450, doc.lastAutoTable.finalY + 22, 10, 10, "F");
        doc.rect(200, doc.lastAutoTable.finalY + 22, 10, 10);
      } else if (!this.solicitud) {
        doc.rect(200, doc.lastAutoTable.finalY + 22, 10, 10);
        doc.rect(450, doc.lastAutoTable.finalY + 22, 10, 10);
      }

      doc.setFillColor(196, 196, 196);
      doc.rect(40, doc.lastAutoTable.finalY + 42, 516, 10, "F");
      //doc.setFontType("bold");
      doc.text("Motivo de la visita", 42, doc.lastAutoTable.finalY + 51);
      // doc.setFontType("normal");
      doc.text(this.detalles, 46, doc.lastAutoTable.finalY + 65);
      doc.rect(40, doc.lastAutoTable.finalY + 53, 516, 40);

      const pdfOutput = doc.output("blob");

      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfOutput);

      // Open the PDF preview in a new window
      window.open(pdfUrl, "_blank");
    },

    emailIn() {
      emailjs.init("user_QA8qMBuyHCQIHTgR0AsPx");
    },
    enviar(fecha, embarcacion, muelle, detalles, usuario, status, operacion, correo) {
      var template_params = {
        fecha: fecha,
        embarcacion: embarcacion,
        muelle: muelle,
        detalles: detalles,
        usuario: usuario,
        status: status,
        operacion: operacion,
        correo: correo,
      };

      emailjs.send("gmail", "cambioguardia", template_params).then(
        function (response) {
          if (response.text === "OK") {
          }
          console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
        },
        function (err) {
          alert("Ocurrió un problema al enviar el correo");
          console.log("FAILED. error=", err);
        }
      );
    },

    csvfile(event) {
      let file = event.target.files[0];
      let pasajerosArray = [];
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          console.log(results.data); // Aquí puedes procesar tus datos CSV
          this.pasajeros = results.data;
          // Lógica para manejar los datos del CSV
          this.resetFileInput(); // Reinicia el input de archivo después de procesar
        },
      });
    },

    resetFileInput() {
      // Reinicia el valor del input de archivo para permitir seleccionar el mismo archivo de nuevo
      this.$refs.csv.value = "";
    },

    mostrarComprobante(item) {
      this.limpiar();
      this.folio = item.folio;
      this._id = item._id;
      this.aprobacionAmls = item.aprobacionAmls;
      this.detalles = item.detalles;
      this.aprobacionApi = item.aprobacionApi;
      this.usuario = item.usuario;
      this.muelle = item.muelle;
      this.paseLista = item.pasDeLista;
      if (item.material.length == 2) {
        this.solicitud = "Ingreso y Retiro";
      } else if (item.material[0] == "ingreso") {
        this.solicitud = "Ingreso";
      } else if (item.material[0] == "retiro") {
        this.solicitud = "Retiro";
      }

      this.compania = item.compania;
      this.tipo = item.tipo;

      var fechaAprobacion = item.fechaAprobacion;
      var fechaActual = new Date();
      var fechaAprobacionDate = new Date(fechaAprobacion);
      var minutoSumar = 5;

      fechaAprobacionDate.setMinutes(fechaAprobacionDate.getMinutes() + minutoSumar);

      if (fechaActual >= fechaAprobacionDate) {
        this.bandera = true;
      } else {
        this.bandera = false;
      }

      this.estado = item.estado;
      this.compania = item.compania;

      this.fecha_solicitud = item.fecha.join(" al ");

      // this.listarAgencia(item.agencia);
      this.nombre = item.usuario[0].nombre;
      this.cargo = item.usuario[0].cargo;
      var solic_fec = item.fecha;
      var fecha = new Date();
      var options = { year: "numeric", month: "long", day: "numeric" };
      this.operacion = item.operacion;
      this.tipoServicio = item.tipoServicio;
      this.fecha = fecha.toLocaleDateString("es-ES", options);
      this.embarcacion = item.embarcacion;
      this.pasajeros = item.pasajeros;
      this.listarDetalles(item._id);

      this.crearPDF();
    },

    printDiv() {
      var objeto = document.getElementById("solicitudGuardia"); //obtenemos el objeto a imprimir
      var ventana = window.open("", "_blank"); //abrimos una ventana vacía nueva
      ventana.document.write(objeto.innerHTML); //imprimimos el HTML del objeto en la nueva ventana
      ventana.document.close(); //cerramos el documento
      ventana.print(); //imprimimos la ventana
      ventana.close(); //cerramos la ventana
    },

    printDivPasajeros() {
      var doc = new jsPDF("p", "pt", "a4");
      var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      var startX = 40;
      var startY = 60;

      doc.setFontSize(10);
      doc.setFontType("bold");
      doc.text("Solicitud de Entrada", pageWidth / 2, 120, { align: "center" });
      doc.text("CG" + this.folio, pageWidth / 2, 130, { align: "center" });
      doc.addImage(
        this.imgData,
        "JPEG",
        startX,
        (startY += 20),
        this.company_logo.w,
        this.company_logo.h
      );
      doc.addImage(
        this.imgData,
        "JPEG",
        (startX += 420),
        startY,
        this.company_logo.w,
        this.company_logo.h
      );
      doc.setFontType("normal");
      doc.text("Frontera, Tab. a: " + this.fecha, 365, 160);
      doc.setFontType("bold");
      if (this.operacion.length == 2) {
        doc.text("Solicitud de Embarque y Desembarque", 365, 175);
      } else if (this.operacion[0] == "Embarque") {
        doc.text("Solicitud de Embarque", 365, 175);
      } else if (this.operacion[0] == "Desembarque") {
        doc.text("Solicitud de Desembarque", 365, 175);
      }

      //Datos de Agencia

      doc.setFontType("normal");
      doc.text("Nombre del Solicitante", 40, 250);
      doc.line(170, 253, 530, 253);
      doc.text("Cargo", 40, 265);
      doc.line(170, 268, 530, 268);
      doc.text("Agencia Naviera", 40, 280);
      doc.line(170, 283, 530, 283);

      doc.text(this.nombre, 180, 250);
      doc.text(this.cargo, 180, 265);
      doc.text(this.agenciasUsuario.nombre, 180, 280);

      doc.text("Contratista", 40, 300);
      doc.text("Armador", 180, 300);
      doc.text("Prestador de Servicios", 290, 300);
      doc.text("Cesionario", 430, 300);

      if (this.tipo == "Contratista") {
        doc.rect(130, 292, 10, 10, "F");
        doc.rect(250, 292, 10, 10);
        doc.rect(390, 292, 10, 10);
        doc.rect(500, 292, 10, 10);
      } else if (this.tipo == "Armador") {
        doc.rect(130, 292, 10, 10);
        doc.rect(250, 292, 10, 10, "F");
        doc.rect(390, 292, 10, 10);
        doc.rect(500, 292, 10, 10);
      }
      if (this.tipo == "Prestador de Servicios") {
        doc.rect(130, 292, 10, 10);
        doc.rect(250, 292, 10, 10);
        doc.rect(390, 292, 10, 10, "F");
        doc.rect(500, 292, 10, 10);
      } else if (this.tipo == "Cesionario") {
        doc.rect(130, 292, 10, 10);
        doc.rect(250, 292, 10, 10);
        doc.rect(390, 292, 10, 10);
        doc.rect(500, 292, 10, 10, "F");
      }

      //Tabla de Pasajeros
      var columns = [
        { title: "Nombre", dataKey: "nombre" },
        { title: "Compañia", dataKey: "compania" },
        { title: "Puesto", dataKey: "puesto" },
        { title: "No. de Licencia", dataKey: "noLicencia" },
      ];

      var rows = [];

      this.pasajeros.map((x) => {
        rows.push({
          nombre: x.nombre + " " + x.apellidoPaterno + " " + x.apellidoMaterno,
          compania: x.compania,
          puesto: x.puesto,
          noLicencia: x.noLicencia,
        });
      });
      doc.autoTable(columns, rows, {
        theme: "grid",
        headerStyles: {
          fillColor: [255, 255, 255],
          textColor: [12, 1, 1],
          fontSize: 8,
        },

        styles: {
          overflow: "linebreak",

          lineWidth: 1,
          lineColor: [0, 0, 0],
        },
        margin: { top: 330 },
      });

      doc.save("pasajeros.pdf");
    },

    mostrarComprobantePasajero(item) {
      this.limpiar();
      this.operacion = item.operacion;
      this.listarAgencia(item.agencia);
      this.folio = item.folio;
      this.nombre = item.usuario[0].nombre;
      this.cargo = item.usuario[0].cargo;
      var solic_fec = item.fecha;
      var fecha = new Date();
      var options = { year: "numeric", month: "long", day: "numeric" };
      var fec = new Date(solic_fec);
      this.fecha_solicitud = fec.toLocaleString();
      this.fecha = fecha.toLocaleDateString("es-ES", options);
      this.embarcacion = item.embarcacion;
      this.listarDetalles(item._id);
      this.tipo = item.tipo;

      this.comprobanteModalPasajero = 1;
    },
    mostrarDatosAgencia() {
      this.listarAgencia(this.agencia);
    },

    ocultarComprobante(item) {
      this.comprobanteModal = 0;
    },
    ocultarComprobantePasajeros(item) {
      this.comprobanteModalPasajero = 0;
    },

    mostrarNuevo() {
      this.limpiar();
      this.dialogNuevaSolicitud = true;
      this.editedIndex = false;
      this.e1 = 1;
    },
    ocultarNuevo() {
      this.dialogNuevaSolicitud = false;
      this.limpiar();
    },

    eliminarPasajero(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },
    eliminarAdjunto(arr, item) {
      this.eliminarAdjuntoEndpoint(item);

      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

    listarPasajeros() {
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      let me = this;
      axios
        .get(
          "pasajeros/list?valor=" +
            this.texto +
            "&agencia=" +
            this.$store.state.usuario.agencia,
          configuracion
        )
        .then(function (response) {
          me.passenger = response.data;
          if (me.passenger.length == 0) {
            swal(
              "Error",
              "Favor de registrar a los pasajeros en el modulo de mis pasajeros",
              "error"
            );
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarAgencia(id) {
      let me = this;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .get("agencia/query?_id=" + id, configuracion)
        .then(function (response) {
          me.agenciasUsuario = response.data;
          me.agenciaDatos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectEmbarcaciones() {
      let me = this;
      let embarcacionArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("embarcacion/listActivos", configuracion)
        .then((response) => {
          embarcacionArray = response.data;
          embarcacionArray.map(function (x) {
            me.embarcaciones.push({ text: x.nombre, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectAgencias() {
      let me = this;
      let agencaiArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("agencia/list", configuracion)
        .then((response) => {
          agencaiArray = response.data;
          agencaiArray.map(function (x) {
            me.agencias.push({ text: x.nombre, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectPasajeros() {
      let me = this;
      let pasajerosArray = [];
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .get("pasajeros/list?agencia=" + this.$store.state.usuario.agencia, configuracion)
        .then((response) => {
          pasajerosArray = response.data;
          pasajerosArray.map(function (x) {
            me.pasajerosList.push({
              text: x.nombre_completo,
              value: x._id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    guardiaVisitante() {
      if (this.tipoServicio == "Cambio de Guardia") {
        this.cabeceraDetalles[2].text = "N° de Libreta de Mar";
      } else {
        this.cabeceraDetalles[2].text = "Identificacion";
      }
    },

    validar() {
      this.valida = 0;
      this.validaMensaje = [];
      if (!this.pasajeros.destino) {
        this.validaMensaje.push("El destino es obligatorio");
      }
      return this.valida;
    },

    agregarDetalle(data) {
      this.alert = true;
      this.errorRfc = null;
      if (this.encuentra(data.nombre_completo) == true) {
        this.$toasted.show("El pasajero ya ha sido agregado", {
          theme: "bubble",
          type: "error",
          position: "bottom-center",
          duration: 5000,
        });
      } else {
        this.pasajeros.push({
          nombre_completo: data.nombre_completo,
          compania: data.compania,
          destino: "",
          estatus: "",
        });
        this.rfc = "";
        this.$toasted.show("Pasajero agregado exitosamente", {
          theme: "toasted-primary",
          type: "success",
          position: "bottom-center",
          duration: 5000,
        });
      }
    },
    mostrarModalPasajero() {
      this.dialog = 1;
    },
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.pasajeros.length; i++) {
        if (this.pasajeros[i].nombre_completo == id) {
          sw = true;
        }
      }
      return sw;
    },
    limpiar() {
      this._id = "";

      (this.usuario = ""),
        (this.folio = ""),
        (this.agencia = ""),
        (this.fecha = ""),
        (this.embarcacion = ""),
        (this.muelle = ""),
        (this.detalles = ""),
        (this.dates = ""),
        (this.tipo = ""),
        (this.compania = ""),
        (this.agencia = ""),
        (this.operacion = []),
        (this.material = ""),
        (this.agenciasUsuario = []),
        (this.pasajeros = []),
        (this.valida = 0),
        (this.validaMensaje = []),
        (this.editedIndex = false);
      this.file = [];
      this.buscarFolio = "";
      this.fechas = [];
      this.date = "";
    },
    handleFileUpload(e) {
      this.file = e;
    },
    async guardar() {
      let me = this;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      let adjuntos;

      this.loading = true;

      if (this.editedIndex) {
        let links = [];

        const datos = {
          _id: this._id,
          embarcacion: this.embarcacion,
          usuario: this.$store.state.usuario._id,
          muelle: this.muelle,
          folio: this.folio,
          detalles: this.detalles,
          pasajeros: this.pasajeros,
          tipo: this.tipo,
          fecha: this.fechas,
          compania: this.compania,
          agencia: this.agencia,
          operacion: this.operacion,
          material: this.material_muelle,
          tipoDeEntradas: this.tipoDeEntradas,
          inicioPrograma: new Date(this.fechas[0]),
          terminoPrograma: this.fechas[1]
            ? new Date(this.fechas[1])
            : new Date(this.fechas[0]), // Si dates[1] es null, usa dates[0]
        };

        if (me.file) {
          adjuntos = me.file;
          const uploadPromises = adjuntos.map((adjunto) => uploadDocument(adjunto));
          const urls = await Promise.all(uploadPromises);
          urls.forEach((url) => links.push(url));
          datos.adjunto = links;
        }

        axios
          .put("cambioGuardia/update", datos, configuracion)
          .then(function (response) {
            swal(
              "Solicitud de Embarque/Desembarque de Personal Actualizada",
              "Solicitud de acceso al muelle en espera de aprobación",
              "success"
            );
            me.ocultarNuevo();
            me.loading = false;
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            swal(
              "Error",
              "Error al guardar la solicitud, veriificar los datos ingresados",
              "error"
            );
            me.loading = false;

            me.ocultarNuevo();
          })
          .finally(() => {
            me.loading = false;
          });
      } else {
        let links = [];
        if (this.file.length == 0 || !this.detalles) {
          this.snackbar = true;
          this.loading = false;
          this.text = "Ingrese los adjuntos del pasajero y los detalles de la solicitud";
          return;
        }
        if (me.file) {
          adjuntos = me.file;
          const uploadPromises = adjuntos.map((adjunto) => uploadDocument(adjunto));
          const urls = await Promise.all(uploadPromises);
          urls.forEach((url) => links.push(url));
        }

        const registro = {
          usuario: this.$store.state.usuario._id,
          folio: this.folio,
          muelle: this.muelle,
          detalles: this.detalles,
          fecha: this.fechas,
          pasajeros: this.pasajeros,
          adjunto: links,
          tipo: this.tipo,
          compania: this.compania,
          agencia: this.agenciaDatos._id,
          operacion: this.operacion,
          material: this.material_muelle,
          tipoDeEntradas: this.tipoDeEntradas,
          inicioPrograma: new Date(this.fechas[0]),
          terminoPrograma: this.fechas[1]
            ? new Date(this.fechas[1])
            : new Date(this.fechas[0]),
        };

        // Solo agrega `embarcacion` si tiene un valor válido
        if (this.embarcacion) {
          registro.embarcacion = this.embarcacion;
        }

        axios
          .post("cambioGuardia/add", registro, configuracion)
          .then(function (response) {
            swal(
              "Nueva solicitud de Embarque/Desembarque de Personal FOLIO:" +
                " CG" +
                response.data.folio,
              "Nueva solicitud de acceso al muelle en espera de aprobación",
              "success"
            );
            me.close();
            me.ocultarNuevo();
            me.listar();
            me.loading = false;
            me.limpiar();
          })
          .catch(function (error) {
            me.loading = false;

            swal(
              "Error",
              "Error al guardar la solicitud, veriificar el campo de Destino o Motivo ingresado",
              "error"
            );
          });
      }
    },
    descargarAdjuntos(adjuntos) {
      window.open(adjuntos, "_blank");
    },
    listar() {
      this.loading = true;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      let me = this;

      axios
        .post("cambioGuardia/list?page=" + this.page, this.arr, configuracion)
        .then(function (response) {
          console.log(response);
          me.cambiosGuardia = response.data.reg;
          me.totalPages = response.data.totalPaginas;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    obtenerDatosPorFolio() {
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .get("cambioGuardia/queryFolio?folio=" + this.folioOtraSolicitud, configuracion)
        .then(function (response) {
          if (response.data.agencia == me.$store.state.usuario.agencia) {
            me.llenarFolio(response.data);
          } else {
            swal("Error", "Error al editar la solicitud, folio no encontrado", "error");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    buscarRfc() {
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      let me = this;
      axios
        .get("pasajeros/busquedaRfc?_id=" + this.rfc, configuracion)
        .then(function (response) {
          me.agregarDetalle(response.data);
        })
        .catch(function (error) {
          swal(
            "Error",
            "El RFC ingresado no existe, verifique los datos ingresados",
            "error"
          );
        });
    },

    listarDetalles(id) {
      let me = this;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .get("cambioGuardia/query?_id=" + id, configuracion)
        .then(function (response) {
          me.pasajeros = response.data.pasajeros;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    guardarPasajero() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "pasajeros/add",
          {
            agencia: this.$store.state.usuario.agencia,

            nombre_completo: this.nombreP,

            compania: this.companiaP,
          },
          configuracion
        )
        .then(function (response) {
          swal("Pasajero agregado", "Pasajero agregado exitosamente", "success");
          me.selectPasajeros();

          me.close();
        })
        .catch(function (error) {
          me.close(), swal("Error", "Verifique los datos ingresados", "error");
        });
    },

    listarEmbarcacion(fecha, embar, muelle, detalles, usuario, operacion, correo) {
      let header = { Token: this.$store.state.token };
      let me = this;
      let embarcacion;

      let configuracion = { headers: header };
      axios
        .get("embarcacion/query?_id=" + embar, configuracion)
        .then(function (response) {
          embarcacion = response.data;
          var fechaLocal;
          status = "en proceso";

          me.enviar(
            fecha,
            embarcacion,
            muelle,
            detalles,
            usuario,
            status,
            operacion,
            correo
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verGuardia(item) {
      this.limpiar();
      this.fecha = item.fecha;
      this.folio = item.folio;
      this.muelle = item.muelle;
      this.detalles = item.detalles;
      this.agencia = item.agencia._id;
      this.tipoDeEntradas = item.tipoDeEntradas;
      this.embarcacion = item.embarcacion._id;
      this.listarDetalles(item._id);
      this.verNuevo = 1;
    },

    editItem(item) {
      this.limpiar();
      this.agencia = item.agencia;
      //this.listarAgencia(item.agencia);
      this.fecha = item.fecha;
      this.folio = item.folio;
      this.adjuntosLista = item.adjunto;
      this.detalles = item.detalles;
      this.muelle = item.muelle;
      if (item.embarcacion) {
        this.embarcacion = item.embarcacion._id;
      }
      this.fechas = item.fecha;
      this.tipo = item.tipo;
      this.compania = item.compania;
      this.operacion = item.operacion;
      this.tipoDeEntradas = item.tipoDeEntradas;
      this.material_muelle = item.material;
      this.retiro_mat = item.retiro_mat;
      this.ingreso_mat = item.ingreso_mat;
      this.listarDetalles(item._id);
      this.dialogNuevaSolicitud = true;
      this._id = item._id;
      this.folio = item.folio;
      this.fecha = item.fecha;
      this.detalles = item.detalles;
      this.editedIndex = true;
      this.dialog = false;
    },

    llenarFolio(item) {
      this.limpiar();
      this.agencia = item.agencia;
      this.listarAgencia(item.agencia);
      this.fecha = item.fecha;
      this.folio = item.folio;
      this.detalles = item.detalles;
      this.muelle = item.muelle;
      this.embarcacion = item.embarcacion._id;
      this.fechas = item.fecha;
      this.tipo = item.tipo;
      this.compania = item.compania;
      this.operacion = item.operacion;

      this.material_muelle = item.material;
      this.retiro_mat = item.retiro_mat;
      this.ingreso_mat = item.ingreso_mat;
      this.listarDetalles(item._id);

      this._id = item._id;
      this.folio = item.folio;
      this.fecha = item.fecha;
      this.detalles = item.detalles;
    },

    activarDesactivarMostrar(accion, item, folio) {
      this.adModal = 1;
      this.adNombre = folio.folio;
      this.adId = folio;
      this._id = item._id;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else if (accion == 3) {
        this.adAccion = 3;
      } else {
        this.adMmodal = 0;
      }
    },
    // activar() {
    //   let me = this;
    //   let header = { Token: this.$store.state.token };
    //   let configuracion = { headers: header };
    //   axios
    //     .put(
    //       "cambioGuardia/activate",
    //       { _id: this._id, aprobacionAmls: this.$store.state.usuario.nombre },
    //       configuracion
    //     )
    //     .then(function (response) {
    //       me.listarEmbarcacion(
    //         response.data.fecha.join(" al "),
    //         response.data.embarcacion,
    //         response.data.muelle,
    //         response.data.detalles,
    //         response.data.operacion,
    //         response.data.usuario.nombre
    //       );
    //       me.comprobanteModal = 0;
    //       swal(
    //         "Solicitud Aprobada",
    //         "Solicitud de Embarque y Desembarque de Personal aprobada con exito",
    //         "success"
    //       );
    //       (me.adModal = 0),
    //         (me.adAccion = 0),
    //         (me.adNombre = ""),
    //         (me.adId = ""),
    //         me.listar();
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },

    activar() {
      let me = this;

      this.loading = true;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .put(
          "cambioGuardia/activate",
          {
            _id: this.itemSelected._id,
          },
          configuracion
        )
        .then(function (response) {
          me.dialogAut1 = false;
          swal(
            "Solicitud Aprobada",
            "Solicitud de Embarque y Desembarque de Personal aprobada con exito",
            "success"
          );

          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          me.itemSelected = [];
          this.loading = false;
        });
    },

    activarApi() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let cancelacion = "";
      axios
        .put("cambioGuardia/finalizarServicio", { _id: this._id }, configuracion)
        .then(function (response) {
          me.comprobanteModal = 0;
          swal("Solicitud Finalizada", "Servicio finalizado con exito", "success");

          (me.adModal = 0),
            (me.adAccion = 0),
            (me.adNombre = ""),
            (me.adId = ""),
            me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      console.log(this.$store.state.usuario.nombre);
      let configuracion = { headers: header };
      axios
        .put(
          "cambioGuardia/deactivate",
          {
            _id: this._id,
            aprobacionAmls: this.$store.state.usuario.nombre,
            motivo_cancelacion: this.motivo_cancelacion,
          },
          configuracion
        )

        .then(function (response) {
          (me.adModal = 0), (me.adAccion = 0), (me.comprobanteModal = 0);
          (me.adNombre = ""), (me.adId = ""), me.listar();
          me.listarEmbarcacionCancelada(
            response.data.fecha.join(" al "),
            response.data.embarcacion,
            response.data.muelle,
            response.data.detalles,
            response.data.operacion,
            response.data.usuario.nombre,
            me.motivo_cancelacion,
            response.data.usuario.email
          );

          swal(
            "Solicitud Cancelada",
            "Solicitud de Embarque y Desembarque de Personal Cancelada con exito",
            "success"
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    checkDataStepper(step) {
      const stepsFields = {
        1: [this.dateRangeText, this.muelle, this.compania, this.tipo],
        2: [this.pasajeros.length > 0],
        3: [],
      };

      const requiredFields = stepsFields[step];
      const isAnyFieldMissing = requiredFields.some((field) => !field);

      if (isAnyFieldMissing) {
        this.text = "Todos los campos son obligatorios";
        this.snackbar = true;
      } else {
        this.e1 = step + 1; // Avanza al siguiente paso
      }
    },

    eliminarAdjuntoEndpoint(file) {
      let me = this;
      this.loading = true;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .post(
          "cambioGuardia/eliminar_adjunto",
          {
            _id: this._id,
            url: file,
          },
          configuracion
        )

        .then(function (response) {})
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    mostrarDialogAut1(item) {
      this.itemSelected = item;
      this.dialogAut1 = true;
    },

    mostrarDialogAut2(item) {
      this.itemSelected = item;
      this.dialogAut2 = true;
    },

    autorizarOpib() {
      let me = this;
      this.loading = true;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .put(
          "cambioGuardia/autorizar_opib",
          {
            _id: this.itemSelected._id,
          },
          configuracion
        )

        .then(function (response) {
          swal("Solicitud Confirmada", "Solicitud confirmada con exito", "success");
          me.dialogAut2 = false;
          me.itemSelected = [];

          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    imprimirPaseAcceso(item) {
      const datos = {
        embarcacion:
          item.embarcacion && item.embarcacion.nombre ? item.embarcacion.nombre : "N/A",
        muelle: item.muelle,
        folio: item.folio,
        _id: item._id,
        agencia: item.agencia.nombre,
        createdAt: item.createdAt,
      };
      generateAccesPersonal(datos);
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    close() {
      this.dialog = false;
    },

    filtroLabelPush(tipo) {
      if (tipo == "folio") {
        let existe = this.arr.findIndex((e) => e.field == "folio");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "folio",
          value: this.folio_filter,
          label: "Folio : " + this.folio_filter,
          collection: "rf",
        });
      } else if (tipo == "embarcacion") {
        let existe = this.arr.findIndex((e) => e.field == "embarcacion");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "embarcacion",
          value: this.embarcacion_filter.value,
          label: "Embarcación: " + this.embarcacion_filter.text,
          collection: "embarcacion",
        });
      } else if (tipo == "tipo") {
        let existe = this.arr.findIndex((e) => e.field == "tipo");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "tipo",
          value: this.tipo_filter,
          label: "Tipo : " + this.tipo_filter,
          collection: "rf",
        });
      } else if (tipo == "muelle") {
        let existe = this.arr.findIndex((e) => e.field == "muelle");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "muelle",
          value: this.muelle_filter,
          label: "Muelle : " + this.muelle_filter,
          collection: "rf",
        });
      } else if (tipo == "estado") {
        let existe = this.arr.findIndex((e) => e.field == "estado");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "estado",
          value: this.estatus_filter.value,
          label: "Estatus : " + this.estatus_filter.text,
          collection: "rf",
        });
      } else if (tipo == "createdAt") {
        const fecha_inicio = new Date(this.fecha_inicio_filter);
        const fecha_fin = new Date(this.fecha_fin_filter);
        let existe = this.arr.findIndex((e) => e.field == "createdAt");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "createdAt",
          value: {
            $gte: fecha_inicio,
            $lte: fecha_fin,
          },
          label: "Entre : " + this.fecha_inicio_filter + " y " + this.fecha_fin_filter,
          collection: "rf",
        });
      }

      this.showFilterFolio = false;
      this.showFilterEmbarcacion = false;
      this.showFilterProcedencia = false;
      this.showFilterMuelle = false;
      this.showFilterEstatus = false;
      this.showFilterFecha = false;
      this.showFilterTipo = false;
      this.listar();
      // this.showFilterFecha = false;
      // this.showFilterOperador = false;
      // this.showFilterTipoUnidad = false;
    },
    eliminarFiltro(index) {
      this.arr.splice(index, 1);
      this.listar();
    },

    triggerFileInput() {
      this.$refs.csv.click();
    },

    agregarDetalle() {
      this.pasajeros.unshift({
        nombre_completo: "",
        compania: "",
        libreta_mar: "",
        destino: "",
      });
    },

    mostrarDocumentacion(item) {
      this.dialogDocumentos = true;
      this.documentos_viz = item.adjunto;
      this.pdfLink = null;
    },
    viewPdf(url) {
      this.pdfLink = url;
    },

    async generarPdfBackend(item) {
      this.loading = true;

      await generarPdfCG(item)
        .then((e) => {
          const base64PDF = e.data;
          const blob = this.base64ToBlob(base64PDF, "application/pdf");
          const url = URL.createObjectURL(blob);
          // Abre el PDF en una nueva ventana
          window.open(url, `_blank`);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    mostrarDialogCancel(item) {
      if (!item.pasajeros || !Array.isArray(item.pasajeros)) {
        return false;
      }

      // Verifica si algún pasajero tiene entradas en su access_logs
      const exist_access = item.pasajeros.some(
        (pasajero) =>
          Array.isArray(pasajero.access_logs) && pasajero.access_logs.length > 0
      );

      if (exist_access) {
        this.$notify({
          title: "¡Alerta!",
          text: "No puede cancelar una solicitud con ingresos registrados",
          type: "warning",
        });
        return;
      }

      this.dialogCancell = true;
      this.itemSelected = item;
    },

    async cancellSolicitud() {
      this.loading = true;
      let me = this;
      let _id = this.itemSelected._id;
      await cancelCambioGuardia(_id, this.motivo_cancell)
        .then((e) => {
          me.$notify({
            title: "¡Éxito!",
            text: "La operación se completo con éxito",
            type: "success",
          });
          me.dialogCancell = false;
          me.listar();
          me.motivo_cancell = "";
        })
        .catch((err) => {
          me.$notify({
            title: "Alerta!",
            text:
              "Por favor, inténtalo de nuevo o verifica los campos obligatorios." + err,
            type: "warning",
          });
        })
        .finally(() => {
          me.loading = false;
        });
    },

    // TODO: Crea una funcion para realizar el fetch y buscar el folio si encuentra el folio rellenar todos los inputs con la informacion que trae la consulta de lo contrario manda un mensaje de alerta con el texto de folio no encontrado

    formatFolio(folio, muelle, created) {
      const folio_number = folio.toString().padStart(4, "0");
      const date = new Date(created);
      const day = date.getUTCDate().toString().padStart(2, "0"); // Asegura dos dígitos
      const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
      const year = date.getUTCFullYear();
      let muelle_folio = "";
      if (
        muelle == "CHILTEPEC" ||
        muelle == "MUELLE DE TANQUES" ||
        muelle == "MUELLE PESCADORES CHILTEPEC"
      ) {
        muelle_folio = "CH";
      } else {
        muelle_folio = "FR";
      }
      let clave_muelle = "";
      switch (muelle) {
        case "ESPADAÑAL":
          clave_muelle = "PAR";
          break;
        case "CENTRO DE REPARACIONES NAVALES":
          clave_muelle = "PAR";
          break;
        case "MUELLE PESCADORES FRONTERA":
          clave_muelle = "DEP";
          break;
        case "MUELLE FISCAL":
          clave_muelle = "FIS";
          break;
        case "PARTICULAR":
          clave_muelle = "PAR";
          break;
        case "MUELLE DE TANQUES":
          clave_muelle = "PAR";
          break;
        case "MUELLE PESCADORES CHILTEPEC":
          clave_muelle = "PES";
          break;
        case "SANCHEZ MAGALLANES":
          clave_muelle = "PAR";
          break;
        case "MUELLE DE TANQUES":
          clave_muelle = "PAR";
          break;
        case "MUELLE COSUGO":
          clave_muelle = "PAR";
          break;
        case "MUELLE PRIVADO CARLOS DAVID":
          clave_muelle = "PAR";
          break;
      }
      //85
      if (folio <= 85) {
        return folio_number;
      } else {
        let otro_folio = folio_number - 85;
        const folio_number_2 = otro_folio.toString().padStart(4, "0");
        return `${folio_number_2}/${muelle_folio}/${clave_muelle}/${day}${month}${year}`;
      }
    },

    base64ToBlob(base64, contentType) {
      const byteCharacters = atob(base64);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays, { type: contentType });
    },

    nuevaSolicitud(data) {
      this.limpiar();
      this.agencia = data.agencia;
      // this.listarAgencia(data.agencia);
      this.fecha = data.fecha;
      this.folio = "";
      this.detalles = data.detalles;
      this.muelle = data.muelle;
      this.embarcacion =
        data.embarcacion && data.embarcacion._id ? data.embarcacion._id : "";
      this.fechas = data.fecha;
      this.tipo = data.tipo;
      this.compania = data.compania;
      this.operacion = data.operacion;
      this.material_muelle = data.material;
      this.retiro_mat = data.retiro_mat;
      this.ingreso_mat = data.ingreso_mat;
      this.pasajeros = Array.isArray(data.pasajeros)
        ? JSON.parse(JSON.stringify(data.pasajeros))
        : [];
      this._id = "";
      this.editedIndex = false;
      this.dialogNuevaSolicitud = true;
    },
    async buscar_folio() {
      if (!this.buscarFolio) {
        this.text = "Debes ingresar un folio";
        this.snackbar = true;
        return;
      }
      this.loading = true;
      try {
        let folioGuardia = this.buscarFolio.split("/")[0];
        const response = await buscarFolioCambioGuardia(folioGuardia);
        if (response) {
          this.nuevaSolicitud(response);
        } else {
          this.text = "No se encontró la solicitud";
          this.snackbar = true;
        }
      } catch (error) {
        this.text = "Error al buscar el folio";
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
#agencia {
  margin-left: 5%;
  margin-right: 8%;
}

@media print {
  #cambioGuardia {
    display: table;
    table-layout: fixed;
    padding-top: 2.5cm;
    padding-bottom: 2.5cm;
    height: auto;
  }
}

#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#table_agencia {
  margin-right: 10px;
}

#imagen {
  width: 100px;
}

#imagen2 {
  width: 90px;
}

#fact {
  font-size: 14px;

  text-align: center;
}

#datos {
  float: left;
  margin-top: 0%;
  margin-left: 15%;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 40%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#fa2 {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 90%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
  border: 0.5px solid #ddd;
}

#facarticulo thead {
  padding: 20px;
  background: #31467c;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}

#solicitante {
  width: 60%;
  border-collapse: collapse;
  border-spacing: 1;
  padding: 20px;
  margin-bottom: 15px;
  border: 0.5px solid #ddd;
}

#solicitante thead {
  padding: 20px;
  background: #31467c;
  text-align: center;

  border-bottom: 1px solid #ffffff;
}

#gracias {
  text-align: center;
}

#tituloSolicitante {
  background-color: #808285;
  border: 1px solid #ddd;
  color: #ffffff;
}

#tituloPasajeros {
  background-color: #808285;
  border: 1px solid #ddd;
  color: #ffffff;
}

#texto {
  color: black;
}

.rounded-table {
  border-radius: 10px;
  color: white;

  overflow: hidden; /* Para mantener los bordes redondeados en la tabla */
}

.rounded-table-header {
  background-color: rgb(128, 0, 32);
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.input-filter {
  background-color: rgb(241, 241, 241);
  border-radius: 20px;
  padding: -5px;
  width: 100%;
  height: 40px;
}

.input-filter_seguimiento {
  background-color: rgb(226, 226, 226);
  border-radius: 20px;
  padding: -45px;
  width: 100%;
  height: 25px;
}

.input-filter_title {
  background-color: rgb(29, 29, 29);
  border-radius: 20px;
  padding: -45px;
  color: white;
  width: 100%;
  text-align: center;
  height: 25px;
}

.button-fab {
  bottom: 50px;
  height: 60px;
  position: fixed;
  right: 20px;
  width: 60px;
}

.filter-label {
  color: #b1adad;
  margin-top: -35px;
  margin-left: 40px;
  font-size: 13px;
  font-weight: normal;
}

.filter-chips {
  color: #b1adad;
  padding: 5px;
  margin-top: -41px;
  margin-left: 40px;
}
#pdf-viewer {
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  overflow: hidden;
}
</style>
